import React from 'react'
import { Text, View } from 'oio-react'
import { settingsSiteUrl } from 'config/constants/urls'
import ReportList from 'src/components/Settings/ReportList'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'

const SettingsSiteReports = () => (
   <View>
      <ProtoReturnBar
         display="block[a-d] none[e-f]"
         returnLinkName="Site Settings"
         returnLinkTo={settingsSiteUrl}
      />
      <View display="flex" justifyContent="center">
         <View
            maxWidth="100%[a-c] 600px[d-f]"
            padding="40px 20px">
            <View
               width="100%"
               display="flex"
               flexFlow="column[a-c] row[d-f]">
               <ProtoHeadingBlock
                  contentMaxWidth="100%"
                  title="Reports"
                  description="All reports that have been generated throughout this community can be accessed and re-downloaded here for your convenience. This can be especially helpful for reports that have been generated recently and that take some time to generate."
               />
            </View>
            <View width="100%" padding="40px 0px 15px 0px">
               <Text size="0.9" weight="bold" color="#000" transform="uppercase">
                  Generated Reports
               </Text>
            </View>
            <ReportList targetType="organization" />
         </View>
      </View>
   </View>
)

export default SettingsSiteReports
